import React from "react";

import moment from "moment";

import { incompleteMessage, useUserContext } from "utils";

import { Button, Col, Form, Icon, Row, TextArea, Typography } from "components";

export const Bio = ({ complete, details, editBio, loading, saving, setEditBio, t }) => {
  const { user } = useUserContext();

  return (
    <Row className="margin-top-200">
      <Col>
        <Typography variant="h2" className="section-heading">
          {t("profile.bio.title")} <Icon iconName="klim/edit-element" className="icon inline pointer" size="m" onClick={() => setEditBio(true)} />
        </Typography>
        {details.bio && !editBio ? (
          <Typography variant="paragraph-m" color="grey-600">
            {details.bio}
          </Typography>
        ) : !editBio ? (
          <Typography variant="paragraph-m" color="grey-600">
            {t("profile.bio.placeholder", {
              firstName: user.firstName,
              region: details.region,
              signupYear: moment().subtract(1, "days").format("YYYY"),
            })}
          </Typography>
        ) : (
          <Form name="profile" onFinish={(v) => complete(v)} onFinishFailed={() => incompleteMessage(t("errors.mandatoryFields"))}>
            <Row>
              <Col>
                <TextArea
                  name="bio"
                  label={t("profile.bio.label")}
                  rules={[{ required: false }]}
                  initialValue={
                    details.bio
                      ? details.bio
                      : t("profile.bio.placeholder", {
                          firstName: user.firstName,
                          region: details.region,
                          signupYear: moment().subtract(1, "days").format("YYYY"),
                        })
                  }
                  autoSize={{ minRows: 4 }}
                />
              </Col>
            </Row>
            <Row>
              <Col className="center">
                <Form.Item>
                  <Button type="primary" htmlType="submit" disabled={loading || saving} loading={loading || saving}>
                    {t("profile.bio.button")}
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        )}
      </Col>
    </Row>
  );
};
